import { Component, OnInit, Inject,OnDestroy, ViewEncapsulation } from '@angular/core';
// import { DOCUMENT } from '@angular/platform-browser';
// import * as $ from 'jquery';
import { DOCUMENT } from '@angular/common';
import { ChatbotComponent } from '../chatbot/chatbot.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.css'],
  
})

export class BasicComponent implements OnInit {
  // @Inject(DOCUMENT) private _document
  constructor(public dialog: MatDialog) { 
    
    
  }
  flag1=0;
  flag2=0;
  flag3=0;
  flag4=0;
  flag5=0;
  flag6=0;
  flag7=0;
  flag8=0;
  flag9=0;
  flag10=0;
  flag11=0;
  flag12=0;
  flag13=0;
  flag14=0;
  flag15=0;
  flag16=0;
  flag17=0;
  flag18=0;
  flag19=0;
  flag20=0;
  flag21=0;
  flag22=0;
  flag23=0;
  flag24=0;
  flag25=0;
  flag45=0;
  flag46=0;
  flagweight=0;
  flagmuscle=0;
  newsletter:String="";
dietPlan(){
  var a = prompt("Fat Loss/Muscle Building")
  if(a == "Fat Loss")
  {
    this.flagweight = 1;
    this.flagmuscle = 0;
  }
  else if(a == "Muscle Building")
  {
    this.flagmuscle = 1;
    this.flagweight = 0;
  }
  else{
    alert("Invalid Credentials");
  }
}

  ngOnInit() {
    // this._document.body.style.background = '#E9E9E9';
  }

  loadpic1(){
    this.flag1=1;
    
  }
  hidepic1(){
    this.flag1=0;
  }
  loadpic2(){
    this.flag2=1;
    
  }
  hidepic2(){
    this.flag2=0;
  }
  loadpic3(){
    this.flag3=1;
    
  }
  hidepic3(){
    this.flag3=0;
  }
  loadpic4(){
    this.flag4=1;
    
  }
  hidepic4(){
    this.flag4=0;
  }
  loadpic5(){
    this.flag5=1;
    
  }
  hidepic5(){
    this.flag5=0;
  }
  loadpic6(){
    this.flag6=1;
    
  }
  hidepic6(){
    this.flag6=0;
  }
  loadpic7(){
    this.flag7=1;
    
  }
  hidepic7(){
    this.flag7=0;
  }
  loadpic8(){
    this.flag8=1;
    
  }
  hidepic8(){
    this.flag8=0;
  }
  loadpic9(){
    this.flag9=1;
    
  }
  hidepic9(){
    this.flag9=0;
  }
  loadpic10(){
    this.flag10=1;
    
  }
  hidepic10(){
    this.flag10=0;
  }
  loadpic11(){
    this.flag11=1;
    
  }
  hidepic11(){
    this.flag11=0;
  }
  loadpic12(){
    this.flag12=1;
    
  }
  hidepic12(){
    this.flag12=0;
  }
  loadpic13(){
    this.flag13=1;
    
  }
  hidepic13(){
    this.flag13=0;
  }
  loadpic14(){
    this.flag14=1;
    
  }
  hidepic14(){
    this.flag14=0;
  }
  loadpic15(){
    this.flag15=1;
    
  }
  hidepic15(){
    this.flag15=0;
  }
  loadpic16(){
    this.flag16=1;
    
  }
  hidepic16(){
    this.flag16=0;
  }
  loadpic17(){
    this.flag17=1;
    
  }
  hidepic17(){
    this.flag17=0;
  }
  loadpic18(){
    this.flag18=1;
    
  }
  hidepic18(){
    this.flag18=0;
  }
  loadpic19(){
    this.flag19=1;
    
  }
  hidepic19(){
    this.flag19=0;
  }
  loadpic20(){
    this.flag20=1;
    
  }
  hidepic20(){
    this.flag20=0;
  }
  loadpic21(){
    this.flag21=1;
    
  }
  hidepic21(){
    this.flag21=0;
  }
  loadpic22(){
    this.flag22=1;
    
  }
  hidepic22(){
    this.flag22=0;
  }
  loadpic23(){
    this.flag23=1;
    
  }
  hidepic23(){
    this.flag23=0;
  }
  loadpic24(){
    this.flag24=1;
    
  }
  hidepic24(){
    this.flag24=0;
  }
  loadpic25(){
    this.flag25=1;
    
  }
  hidepic25(){
    this.flag25=0;
  }
  
  loadpic45(){
    this.flag45=1;
    
  }
  hidepic45(){
    this.flag45=0;
  }
  loadpic46(){
    this.flag46=1;
    
  }
  hidepic46(){
    this.flag46=0;
  }
  subs(){
    if(this.newsletter!="")
    alert("Thanks for subscribing");
    else{
      alert("Please mention your email");
    }
  }
  chatbot(){
    const dialogRef = this.dialog.open(ChatbotComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

}
